import { BrowserStorage } from 'utils/browserStorage';

const storageKey = (accountId: number) =>
  `${BrowserStorage.keys.Onboarding.Finished}:${accountId}`;

export const onboardingFinished = {
  is: (accountId: number | null) =>
    accountId !== null && BrowserStorage.get(storageKey(accountId)) === '1',
  mark: (accountId: number | null) => {
    if (accountId !== null) {
      BrowserStorage.set(storageKey(accountId), '1');
    }
  },
};
